import type { FaireProductEntity } from "../../entity_types/product";

export const p_gw383m8ezq: FaireProductEntity = {
  token: "p_gw383m8ezq",
  type: "product",
  name: "Mineral Enriched Moisturizing Lotion for Face & Body",
  brandToken: "b_n34zp8ykn9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fc55aee8ecc0826ade7604d78a0a4d71570400e8c7b7a7b3f029d4f3aee0a2ea.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/052e863283189d50e4db36d6a4b4b37d2a2bde2b8487f71a97446f2d3f2fce77.png",
    "https://cdn.faire.com/fastly/f581aeb5ab13b421747b7a7dc195e1884b48b6dce8a767feedb5c6c2bc22da47.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "We've pioneered a Silica, Sulfur (MSM), Magnesium, Zinc and Copper enhanced moisturizing lotion utilizing Silica's important role in maintaining the body's connective tissue - including skin, hair and nails.\n\nThis unique blend of herbal and botanical oils, combined with the absorbent and therapeutic qualities of Eidon’s Ionic Minerals, penetrates quickly without greasiness. Silica's water bonding qualities attract and hold moisture to the skin. MSM is known as the \"beauty mineral\" because it keeps the complexion clear and youthful. Magnesium, Zinc and Copper have been added to help calm, soothe and rejuvenate the skin. This lotion softens and adds elasticity to dry and/or aging skin. Use as a moisturizer, foundation base, shaving cream, or hair conditioner.\n\nEidon's Mineral Enriched Moisturizing Lotion is free from colorings, perfumes, sodium lauryl sulfate (SLS), sodium laureth sulfate (SLES), parabens, lanolin, phthalates, alcohol, soap and formaldehyde. Vegan and Gluten Free.",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:45.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
